module.exports = __webpack_public_path__ + "img/mypayslip.0bf6af71.svg";